import { CSSProperties } from "react"

import { Employees, Header } from "types/sharedTypes"

import thousandSeparator from "utils/thousandSeparator"

const RegisterTableExport = ({ header, employees }: { header: Header; employees: Employees[] }) => {
    const styles: { [key: string]: CSSProperties } = {
        tableStyle: {
            marginBottom: 48,
            borderSpacing: 0,
            borderCollapse: "collapse",
            textAlign: "left",
            height: "fit-content",
        },
        tbodyTd: {
            border: "1px solid #ddd",
            borderSpacing: 0,
            padding: 8,
            whiteSpace: "nowrap",
        },
        theadTrTh: {
            padding: 8,
            background: "#ddd",
            border: "1px solid #ddd",
            borderSpacing: 0,
            fontFamily: "Open Sans Bold",
            width: "100%",
            whiteSpace: "nowrap",
        },
    }

    const {
        Ssn,
        Name,
        Number,
        EmploymentScope,
        WorkCode,
        GroupLevel,
        Manager,
        LokalKomplettering,
        Samråd,
        YrkesSpecificering,
        KompetensKategori,
        EmploymentStartDate,
        SalaryBasic,
        SalaryProvision,
        SalaryFlexibleProvision,
        SalaryOrganizationalAffiliation,
        CustomizableC1,
        CustomizableC2,
        CustomizableC4,
        CustomizableC5,
        CustomizableC3,
        CustomizableC6,
        CustomizableC7,
        CustomizableC8,
        CustomizableC9,
        CustomizableC10,
        IndividualAgreementsK70,
        IndividualAgreementsK71,
        IndividualAgreementsK72,
        IndividualAgreementsK73,
        // Seem not to be used
        // Age,
        // EmploymentLength,
        // Sex,
    } = header

    return (
        <table className="invisible" style={styles.tableStyle}>
            <thead style={styles.theadTrTh}>
                <tr style={styles.theadTrTh}>
                    <th style={styles.theadTrTh}>{Ssn}</th>
                    <th style={styles.theadTrTh}>{Name}</th>
                    <th style={styles.theadTrTh}>{Number}</th>
                    <th style={styles.theadTrTh}>{EmploymentScope}</th>
                    <th style={styles.theadTrTh}>{WorkCode}</th>
                    <th style={styles.theadTrTh}>{GroupLevel}</th>
                    <th style={styles.theadTrTh}>{Manager}</th>
                    <th style={styles.theadTrTh}>{LokalKomplettering}</th>
                    <th style={styles.theadTrTh}>{Samråd}</th>
                    <th style={styles.theadTrTh}>{YrkesSpecificering}</th>
                    <th style={styles.theadTrTh}>{KompetensKategori}</th>
                    <th style={styles.theadTrTh}>{EmploymentStartDate}</th>
                    <th style={styles.theadTrTh}>{SalaryBasic}</th>
                    <th style={styles.theadTrTh}>{SalaryProvision}</th>
                    <th style={styles.theadTrTh}>{SalaryFlexibleProvision}</th>
                    <th style={styles.theadTrTh}>{SalaryOrganizationalAffiliation}</th>
                    <th style={styles.theadTrTh}>{CustomizableC1}</th>
                    <th style={styles.theadTrTh}>{CustomizableC2}</th>
                    <th style={styles.theadTrTh}>{CustomizableC4}</th>
                    <th style={styles.theadTrTh}>{CustomizableC5}</th>
                    <th style={styles.theadTrTh}>{CustomizableC3}</th>
                    <th style={styles.theadTrTh}>{CustomizableC6}</th>
                    <th style={styles.theadTrTh}>{CustomizableC7}</th>
                    <th style={styles.theadTrTh}>{CustomizableC8}</th>
                    <th style={styles.theadTrTh}>{CustomizableC9}</th>
                    <th style={styles.theadTrTh}>{CustomizableC10}</th>
                    <th style={styles.theadTrTh}>{IndividualAgreementsK70}</th>
                    <th style={styles.theadTrTh}>{IndividualAgreementsK71}</th>
                    <th style={styles.theadTrTh}>{IndividualAgreementsK72}</th>
                    <th style={styles.theadTrTh}>{IndividualAgreementsK73}</th>
                </tr>
            </thead>
            <tbody>
                {employees.map((employee) => (
                    <tr key={`${employee.EmployeeNumber}${Math.random() * 1600}`}>
                        <td style={styles.tbodyTd}>{employee.Ssn}</td>
                        <td style={styles.tbodyTd}>{employee.Name}</td>
                        <td style={styles.tbodyTd}>{employee.EmployeeNumber}</td>
                        <td style={styles.tbodyTd}>{employee.EmploymentScope}</td>
                        <td style={styles.tbodyTd}>{employee.WorkCode}</td>
                        <td style={styles.tbodyTd}>{employee.GroupLevel}</td>
                        <td style={styles.tbodyTd}>{employee.Manager}</td>
                        <td style={styles.tbodyTd}>{employee.LokalKomplettering}</td>
                        <td style={styles.tbodyTd}>{employee.Samråd}</td>
                        <td style={styles.tbodyTd}>{employee.YrkesSpecificering}</td>
                        <td style={styles.tbodyTd}>{employee.KompetensKategori}</td>
                        <td style={styles.tbodyTd}>{employee.EmploymentStartDate}</td>
                        <td style={styles.tbodyTd}>{thousandSeparator(employee.SalaryBasic.toString())}</td>
                        <td style={styles.tbodyTd}>{employee.SalaryProvision}</td>
                        <td style={styles.tbodyTd}>{employee.SalaryFlexibleProvision}</td>
                        <td style={styles.tbodyTd}>{employee.SalaryOrganizationalAffiliation}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC1}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC2}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC3}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC4}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC5}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC6}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC7}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC8}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC9}</td>
                        <td style={styles.tbodyTd}>{employee.FreeC10}</td>
                        <td style={styles.tbodyTd}>{employee.IndividualAgreementsK70}</td>
                        <td style={styles.tbodyTd}>{employee.IndividualAgreementsK71}</td>
                        <td style={styles.tbodyTd}>{employee.IndividualAgreementsK72}</td>
                        <td style={styles.tbodyTd}>{employee.IndividualAgreementsK73}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default RegisterTableExport
